/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/no-runloop, ember/require-tagless-components */
import Component from '@ember/component';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import {
  getDynamicStyles,
  getTableExportData,
  getTablePrintCss,
  parseCell,
} from 'linced-app/utils/table';
import {
  cleanExcelSheetName,
  cleanFileName,
} from '@linc-technologies/linced-common/utils/file-names';
import { isMobile } from '@linc-technologies/linced-common/utils/platform';
import { classNames } from '@ember-decorators/component';

@classNames('table-tools')
export default class TableTools extends Component {
  @service
  csv;

  @service
  excel;

  downloadCSV = true;
  downloadExcel = true;
  print = true;
  title = '';
  fileName = '';
  sheetName = '';
  landscape = false;

  // Data optionally accepts an array of data rows, which will be used raw instead of parsing the table body.
  // Merging cells is not currently supported when using `data` to skip body parsing.
  data = null;

  @tracked
  isMobile;

  init() {
    super.init(...arguments);
    this.isMobile = isMobile();
  }

  parseCell(cell) {
    return parseCell(cell);
  }

  @action
  download(format) {
    let container = this.element.querySelector('md-table-container');
    let data = getTableExportData(
      container.id,
      format,
      this.parseCell,
      this.data,
    );
    let rawFileName = this.fileName || this.title || 'export';
    let rawSheetName = this.sheetName || this.title || this.fileName || 'Data';
    let fileName = cleanFileName(rawFileName);
    let sheetName = cleanExcelSheetName(rawSheetName);

    switch (format) {
      case 'csv':
        fileName += '.csv';
        return this.csv.export(data.rows, { fileName, withSeparator: false });
      case 'xlsx':
        fileName += '.xlsx';
        return this.excel.export(data.rows, {
          merges: data.merges,
          fileName,
          sheetName,
        });
    }
  }

  @action
  handlePrint() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );
    let title = this.title ? `<h1>${this.title}</h1>` : '';
    let styles = getTablePrintCss(this.landscape) + getDynamicStyles();
    printer.document.head.innerHTML = styles;
    printer.document.body.innerHTML =
      title + this.element.querySelector('md-table-container').outerHTML;

    // Remove clear buttons from input fields
    printer.document.body
      .querySelectorAll('.ember-power-select-clear-btn')
      .forEach((el) => (el.innerHTML = ''));

    if (!isEmpty(this.data)) {
      // We have an array of data.  Replace the table's body with one compiled from the provided array.
      let rows = this.data.reduce((rows, row) => {
        let cells = row.map((cell) => `<td>${cell}</td>`);
        rows.push(`<tr>${cells.join('')}</tr>`);
        return rows;
      }, []);

      printer.document.body.querySelector('tbody:not(.hide-print)').innerHTML =
        rows.join('');
    }

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }
}
